import { Stack } from '@mui/material'
import { Chip } from '@mui/material'

type SelectChipProps = {
  label: string
  isSelected: boolean
  onClick: () => void
  key?: string
}

export const SelectChip: React.FC<SelectChipProps> = ({ label, isSelected, onClick, key }) => (
  <Chip
    key={key}
    label={label}
    onClick={onClick}
    size="small"
    sx={{
      minWidth: 'unset',
      height: 32,
      fontSize: '0.8125rem',
      borderRadius: '16px',
      px: '6px',
      bgcolor: isSelected ? 'primary.main' : 'transparent',
      color: isSelected ? 'primary.contrastText' : 'text.primary',
      border: '1px solid',
      borderColor: isSelected ? 'primary.main' : 'rgb(189, 189, 189)',
      '&:hover': { bgcolor: isSelected ? 'primary.dark' : 'rgba(0, 0, 0, 0.04)' },
    }}
  />
)

type ChipRowProps = {
  options: { value: string; label: string }[]
  selected: string[]
  onChange: (values: string[]) => void
}

export const ChipRow: React.FC<ChipRowProps> = ({ options, selected, onChange }) => {
  const toggle = (value: string) =>
    onChange(selected.includes(value) ? selected.filter((v) => v !== value) : [...selected, value])

  return (
    <Stack direction="row" spacing={0.75} sx={{ mb: 1.5, flexWrap: 'wrap', rowGap: 1 }}>
      <SelectChip label="Todos" isSelected={selected.length === 0} onClick={() => onChange([])} />
      {options.map((option) => (
        <SelectChip
          key={option.value}
          label={option.label}
          isSelected={selected.includes(option.value)}
          onClick={() => toggle(option.value)}
        />
      ))}
    </Stack>
  )
}
